export default "__VITE_PUBLIC_ASSET__8b322445__"